import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { ExtendedNotificationComponent } from '@next/core-lib/components';
import {
  AbstractDialog,
  AbstractDialogData,
  AbstractDialogResultData,
} from '@next/core-lib/dialog';
import { FormComponent } from '@next/core-lib/form';
import { TranslatePipe } from '@next/core-lib/i18n';

interface ImportDialogOutputModel {
  file: File;
}

@Component({
  selector: 'app-import',
  templateUrl: './import.component.html',
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormComponent,
    ReactiveFormsModule,
    ExtendedNotificationComponent,
    MatButton,
    MatDialogActions,
    TranslatePipe,
  ],
})
export class ImportComponent extends AbstractDialog<ImportDialogOutputModel> {
  @ViewChild('file', { static: true }) inputFile: ElementRef<HTMLInputElement>;
  selectedFile: File;
  formGroup = new FormGroup({});

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AbstractDialogData,
    protected mdDialogRef: MatDialogRef<
      ImportComponent,
      AbstractDialogResultData<ImportDialogOutputModel>
    >,
  ) {
    super();
  }

  onFileSelected() {
    this.selectedFile = this.inputFile.nativeElement.files[0];
  }
}
